import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/9SjBzyfU7gAum9P6yaEc7g/Mockup_(1x1)_-_OFN4_(E.R).webp';
export function Hero() {
  // Headline and mockup render immediately (no entrance animation) so the
  // largest contentful paint is never delayed by JavaScript.
  return <section className="relative overflow-hidden bg-surface px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-64" data-mp="12860lxyjoar2">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-primary/40" data-id="element-65" data-mp="xbpc32nfnudg" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-66" data-mp="sa9q98dflju0">
        <p className="-mb-2.5 -mt-11 font-display text-lg font-bold tracking-brand text-primary-soft sm:text-2xl" data-id="element-67" data-mp="nc87kojx3mj2">
          🌿BIOMA LÍVIDO™
        </p>
        <h1 className="mx-auto mt-5 max-w-5xl font-display text-lg font-bold text-foreground sm:text-5xl lg:text-6xl" style={{
        fontSize: "21px"
      }} data-id="element-68" data-mp="3d33gb2q0p1mv">
          Recuperá calma y claridad{' '}
          <span className="text-primary-soft" data-id="element-69" data-mp="3j923tk0h7itf">
            sin darle vueltas durante horas a lo que debería ocupar minutos.
          </span>
        </h1>
        <div className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-70" data-mp="39al7s8moke0i">
          <img src={mockupUrl} alt="Mockup del Protocolo Calma Aplicada: 4 volúmenes" width="1254" height="1254" fetchPriority="high" loading="eager" decoding="async" className="aspect-square w-full drop-shadow-2xl" data-id="element-71" data-mp="39cpcgsselh1u" />
        </div>
        <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="3599ik47pxusu">
          <p className="-mb-2 font-display text-base font-bold tracking-label text-highlight sm:text-xl" data-id="element-73" data-mp="35aawqhk16xes">
            PROTOCOLO CALMA APLICADA
          </p>
          <p className="-mb-2.5 mt-3 text-sm leading-relaxed text-foreground-soft sm:text-base" style={{
          fontSize: "15px"
        }} data-id="element-74" data-mp="2vievixmner6c">
            Protocolos, respuestas y rutinas listas para cortar el sobrepensamiento, soltar lo que no depende de vos y saber qué hacer después.
          </p>
          <div className="-mb-3 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-foreground-muted sm:text-sm" data-id="element-75" data-mp="s1rrim0vq2t8">
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-76" data-mp="na9zingu3cke">
              <FileTextIcon className="h-4 w-4 text-primary-soft" data-id="element-77" data-mp="icrs51igt5ei" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-78" data-mp="deyh9v67vn7w">
              <ZapIcon className="h-4 w-4 text-highlight" data-id="element-79" data-mp="161t1cqz4gkku" />
              Acceso inmediato
            </span>
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-80" data-mp="111ol9224lrv5">
          <ActionButton href="#pricing" showTrust data-id="element-81" data-mp="3lqm3c0xhx9vz">
            🌿 QUIERO MI PROTOCOLO DE CALMA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}